const data = {
  shippingTypes:null
}

const set = (shippingTypes) => {
  data.shippingTypes = shippingTypes
}

const get = () => {
  return data.shippingTypes
}

const getDefault = () => {
  // TODO we simply use the first one ... may want to make this configurable, i.e. set the default either as a property or in a config file
  return data.shippingTypes[0]
}

const getInfo = (code) => {
  // get the type
  let s = _getTypeByCode(code)

  let info = {
    code:code,
    packaging:s.title["de"],
    imageUrl:s.image.url,
    price:s.price,
    how:null,
    when:_getDeliveryDay(code)
  }

  switch(s.deliveryMethod) {
    case "digital":
      info.how = "elektronisch via E-Mail"
      break
    case "virtual":
      info.how = "sofort via Whatsapp, SMS, E-Mail, etc."
      break
    case "letter":
      info.how = "Brief A-Post"
      break
    case "parcel":
      info.how = "PostPac Priority"
      break
    default:
      info.how = "unbekannt"
      break
  }
  return info
}

const _getTypeByCode = (code) => {
  return data.shippingTypes.find(shippingType => shippingType.code.toUpperCase() === code.toUpperCase())
}

const _getDeliveryDay = (code) => {
  // get the type
  let shippingType = _getTypeByCode(code)

  // current day of the week and hour
  let now = new Date() // now = new Date(2019, 0, 18, 13)
  let orderDay = now.getDay()
  let orderTime = now.getHours()

  // the delivery week day
  let deliveryInfo = shippingType.deliveryInfo.find(deliveryInfo => deliveryInfo.orderDay === orderDay)
  if(!deliveryInfo) {
    // fallback, in case now deliveryInfo was set
    return "innerhalb von 2 Werktagen"
  }
  let deliveryDay = (orderTime < deliveryInfo.orderTime) ? deliveryInfo.deliveryDayA : deliveryInfo.deliveryDayB

  // get the delivery date
  let daysFromNow = 0
  if(deliveryDay > orderDay) {
    daysFromNow = deliveryDay - orderDay
  }
  else {
    daysFromNow = deliveryDay + 7 - orderDay
  }
  let deliveryDate = now.setDate(now.getDate() + daysFromNow)
  deliveryDate = new Date(deliveryDate)

  // return the info
  if(shippingType.deliveryMethod === "digital") {
    return "sofort via E-Mail"
  }
  else if(shippingType.deliveryMethod === "virtual" ){
    return "sofort via Whatsapp, SMS, E-Mail, etc"
  }
  else {
    return deliveryDate.toLocaleDateString("de-DE", { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' })
  }
}

// TODO instead of having both getTitle and getImage we should have a getInfo function
export default {set, get, getDefault, getInfo}
